import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-toolbar-breadcrumb-section',
    templateUrl: './toolbar-breadcrumb-section.component.html',
    styleUrls: ['./toolbar-breadcrumb-section.component.scss'],
    standalone: false
})
export class ToolbarBreadcrumbSectionComponent implements OnInit {
  @Input()
  breadcrumbs!: Breadcrumb[];

  constructor() {}

  ngOnInit(): void {}
}

export interface Breadcrumb {
  text: string;
  remove: () => void;
  show: boolean;
}
